import { SiterecordCharacteristicsExtended } from './siterecordcharacteristicsextended.model';

export class SiterecordCharacteristics {
  public id: number;
  public characteristicsOrder: number;
  public accuracy: number;
  public period: number;
  public specificLane: string; // LaneType
  public measurementValueType: string; // MeasurementValueType
  public measurementCategory: string; // MeasurementCategoryType
  public siterecordCharacteristicsExtended: SiterecordCharacteristicsExtended;
}



// WEBPACK FOOTER //
// ./src/app/models/siterecordcharacteristics.model.ts